/** HubSpot CRM adapter — STUB. Implements CRMPort. See /adapters/crm/ghl.js for pattern. */
export function createHubspotCRM() {
  const err = () => { throw new Error("HUBSPOT_ADAPTER_NOT_IMPLEMENTED"); };
  return {
    async status() { return { status: "not_connected", vendor: "hubspot" }; },
    async connect() { err(); }, async disconnect() { err(); },
    async syncActors() { err(); }, async syncSignals() { err(); },
    async pushOutcome() { err(); }, async pushActorUpdate() { err(); },
    subscribeToSignals() { return () => {}; },
    async resolveContact() { err(); },
  };
}
